<template>
	<section class="tab-bar">
		<h6>
			<ul class="fx">
				<router-link v-for="(item,index) in listBar" :key="index" :to="{ name: item.routeName}" tag="li">{{item.title}}<i></i></router-link>
			</ul>
		</h6>
	</section>
</template>
<script>
	export default {
		name:"z-tabbar",
		data() {
			return {
				listBar: this.listObj
			}
		},
		/*
		 * 接收父组件数据
		 */
		props: {
			listObj: { //tabbar数组对象
				type: Array,
				default: [{
					title: '标题',
					routeName: 'name'
				}],
			}
		}
	}
</script>
<!-- 添加 scoped “范围”属性CSS限制这个组件只 -->
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	/*tab-bar*/
	.tab-bar h6 {
		height: px-em(88px);
		background-color: $color-white;
		border: 1px solid $color-border;
		border-bottom:none;
		border-top: none;
	}
	
	.tab-bar li {
		height: px-em(88px);
		line-height: px-em(88px);
		position: relative;
		padding: 0 px-em(40px);
		color: $color-font-sub;
		cursor: pointer;
	}
	
	.tab-bar li i {
		position: absolute;
		width: 100%;
		left: 0;
		bottom: 0;
		height: 2px;
	}
	
	.tab-bar li i:after {
		content: '';
		display: block;
		margin: auto;
		height: 2px;
		width: 0px;
		background: $color-white;
		-webkit-transition: width .3s ease, background-color .3s ease;
		transition: width .3s ease, background-color .3s ease
	}
	
	.tab-bar li.router-link-active {
		color: $color-main;
	}
	
	.tab-bar li:hover i:after,
	.tab-bar li.router-link-active i:after {
		width: 100%;
		background: $color-main;
	}
</style>


// WEBPACK FOOTER //
// Tabbar.vue?146a4b53